export default __webpack_public_path__ + "static/media/Clientes (Real Size).cada75cc.svg";